import PropTypes from 'prop-types';
import {window} from 'ssr-window';
import EnvironmentUtils from '@spothero/utils/environment';

export const SEARCH_TYPE = PropTypes.oneOf([
    'address',
    'destination',
    'event',
    'venue',
    'city',
]);

export const GOOGLE_MAPS_LAT_LNG = EnvironmentUtils.isBrowser()
    ? PropTypes.instanceOf(window.google.maps.LatLng)
    : null;
